export default "__VITE_ASSET__b712f894__"